export const teamRequestsCopy = {
  lugar: "Pedidos à equipe",
  gaveta: (n: number) => (n === 0 ? undefined : `${n} em aberto`),
} as const;
